import { render, staticRenderFns } from "./memberDialog.vue?vue&type=template&id=517d06d7&scoped=true&"
import script from "./memberDialog.vue?vue&type=script&lang=js&"
export * from "./memberDialog.vue?vue&type=script&lang=js&"
import style0 from "./memberDialog.vue?vue&type=style&index=0&id=517d06d7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517d06d7",
  null
  
)

export default component.exports